import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStop, faAsterisk} from "@fortawesome/free-solid-svg-icons";

export const waringIcon = <FontAwesomeIcon className="text-warning" icon={faStop} />
export const appealIcon = <FontAwesomeIcon className="text-warning" icon={faAsterisk} />
